import { fetchJson } from './fetchJson';

export const fetcher = (url) =>
  fetchJson('GET', url).then((r) => (r.status === 204 ? r : r.json()));
